// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const AiChatComposerContract = contract({
  name: "AiChatComposer",
  description: "The reusable \"input card\" for any chat surface — auto-growing textarea, image attachments via paperclip and clipboard paste, attachment chips with previews, Send/Stop toggle, controlled value. Drop in below any messages list. Use this when you want the input affordances of `<AIChat>` but you're rendering your own messages list / scrollarea / header (e.g. Studio's left-column chat, where SelectionChip and SettingsPanel sit between messages and composer). For the full canned chat block, use `<AIChat>` instead.",
  import: "@gradeui/ui",
  aliases: ["chat composer","chat input","prompt composer","message input"],
  composesWith: ["AIChat (uses this internally)","Card (host above)","ScrollArea (place messages above)"],
  styleDefaults: {"AIChatComposer":"w-full"},
  props: {
  "value": {
      schema: z.string(),
      design: "content",
      description: "controlled textarea value",
  },
  "onChange": {
      schema: z.unknown(),
      design: "event",
      description: "fires for every textarea change",
  },
  "onSend": {
      schema: z.unknown(),
      design: "event",
      description: "fires when the user submits (Enter or click Send); composer validates that text or attachments exist before firing",
  },
  "isLoading": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "disables the textarea + paperclip and swaps Send for Stop",
  },
  "onStop": {
      schema: z.unknown().optional(),
      design: "event",
      description: "fires when the user clicks Stop; without this, Stop renders disabled",
  },
  "placeholder": {
      schema: z.string().optional(),
      design: "content",
  },
  "maxLength": {
      schema: z.number().optional(),
      design: "knob",
      description: "hard cap passed to the underlying `<textarea>`",
  },
  "showHint": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "show the \"Press Enter… · Paste images\" hint below the card; default true, set false when the host renders its own footer",
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
  },
  },
});
